import { render, staticRenderFns } from "./exit-info.vue?vue&type=template&id=6fe89bdc&scoped=true"
import script from "./exit-info.vue?vue&type=script&lang=js"
export * from "./exit-info.vue?vue&type=script&lang=js"
import style0 from "./exit-info.vue?vue&type=style&index=0&id=6fe89bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe89bdc",
  null
  
)

export default component.exports